<template>
  <div class="shadow flex">
    <div v-if="showFilters" class="bg-white fixed top-0 right-0 bottom-0 left-0 ">aa</div>
    <button @click="openFilterMenu" class="uppercase tracking-wide font-bold text-purple-600 bg-gray-200 flex-shrink-0 px-4 text-sm">Filter</button>
    <input 
    placeholder="Search" 
    type="text" 
    class="border-t flex-grow px-4 py-3 w-full outline-none text-base text-gray-900" 
    v-on:input="searchInput = $event.target.value">
  </div>
</template>

<script>
export default {
  data(){
    return {
      searchInput: '',
      showFilters: false
    }
  },
  props: {
    defaultFilters: {
      type: Array
    }
  },
  watch: {
    searchInput(){
      this.$root.$emit('doSearch', this.searchInput.trim())
    }
  },
  methods: {
    openFilterMenu() {
      this.$root.$emit('openFilterMenu')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
